<script>
export default {
    props: ['data'],
    name: "shopDetailImages",
    data() {
        return {
            swiperOptions1: {
                observer: true,
                observeParents: true,
                simulateTouch: false,
                loop: false,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            },
            swiperOptions2: {
                observer: true,
                observeParents: true,
                // simulateTouch: false,
                // loop: true,
                slidesPerView: 3,
                spaceBetween: '5.1%',
                // centeredSlides: true,
                // centerInsufficientSlides: true,
            },
            activeIndex: 0,
            isShowZoom: false,
            zoomStyle: {
                transform: `translate(0, 0)  scale(2)`,
            },
            maskStyle: {
                left: 0,
                top: 0
            }
        };
    },
    computed: {
        swiper1() {
            return this.$refs.mySwiper1.$swiper
        },
        swiper2() {
            return this.$refs.mySwiper2.$swiper
        }
    },
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {
        showImage(index) {
            this.activeIndex = index;
            this.swiper1.slideToLoop(index);
            this.swiper2.slideTo(index);
        },
        change() { 
            const index = this.swiper1.realIndex;
            this.activeIndex = index;
            this.swiper2.slideTo(index);
        },
        coverMousemove(event){ 
            // console.log(event)
            const box = this.$refs.cover.getBoundingClientRect();
            const mask = this.$refs.mask.getBoundingClientRect();

            // console.log(box)
            const x = event.clientX - box.left;
            const y = event.clientY - box.top;

            let maskX = x - mask.width / 2;
            let maskY = y - mask.height / 2;
            if (maskX < 0) maskX = 0;
            if (maskY < 0) maskY = 0;
            if (maskX + mask.width > box.width) maskX = box.width - mask.width;
            if (maskY + mask.height > box.height) maskY = box.height - mask.height; 
            this.maskStyle = {
                left: maskX + 'px',
                top: maskY + 'px'
            }
            this.zoomStyle = {
                transform: `translate(-${maskX * 2}px, -${maskY * 2}px) scale(2)`
            }
        },
        coverMouseenter() { 
            this.isShowZoom = true;
        },
        coverMouseleave() { 
            this.isShowZoom = false;
        }
    },
};
</script>

<template>
    <div class="shop_detail_images">
        <div class="cover big">
            <div class="cover_swiper" ref="cover" @mousemove="coverMousemove($event)" @mouseenter="coverMouseenter" @mouseleave="coverMouseleave">
                <swiper ref="mySwiper1" :options="swiperOptions1" @slideChangeTransitionStart="change">
                    <swiper-slide v-for="(item, index) in data" :key="index">
                        <div class="layout_bg bg" :style="`background-image: url(${item})`"></div>
                    </swiper-slide>
                </swiper>
                <template v-if="isShowZoom">
                    <div class="mask" ref="mask" :style="maskStyle"></div>
                    <div class="zoom">
                        <div class="layout_bg bg" :style="{ backgroundImage: `url(${data[activeIndex]})`, ...zoomStyle }"></div>
                    </div>
                </template>
            </div>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
        </div>
        <div class="cover pagination only_pc">
            <swiper class="cover_swiper" ref="mySwiper2" :options="swiperOptions2">
                <swiper-slide v-for="(item, index) in data" :key="index">
                    <div class="layout_bg bg" :class="{active: activeIndex == index}" :style="`background-image: url(${item});`"
                    @click="showImage(index)"></div>
                </swiper-slide>
            </swiper>
        </div>
    </div>
</template>

<style scoped lang="scss">
.cover{
    position: relative;
    padding: 0 .5rem;
    @media only screen and (max-width: 750px) {
        padding: 0;
        .mask,
        .zoom{
            display: none;
        }
    }
    .mask{
        position: absolute;
        top: 0;
        left: 0;
        width: 50%;
        height: 50%;
        z-index: 1;
        background: rgba($color: #000000, $alpha: .4);
    }
    .zoom{
        position: absolute;
        top: 0;
        // left: 0;
        left: calc(100% + .5rem);
        width: 100%;
        height: 100%;
        z-index: 1;
        overflow: hidden;
        pointer-events: none;
        .bg{
            transform-origin: 0 0;
            transform: scale(2);
            // transform: translate(0, 0);
        }
    }
    &.big{
        margin-bottom: .25rem;
        .cover_swiper{
            cursor: zoom-in;
        }
    }
    &.pagination{
        .cover_swiper{
            .bg{
                cursor: pointer;
                &::after{
                    content: "";
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    border: 4px solid #000;
                    box-sizing: border-box;
                    display: none;
                }
                &.active{
                    &::after{
                        display: block;
                    }
                }
            }
        }
    }
    .cover_swiper{
        width: 4.9rem;
        position: relative;
        @media only screen and (max-width: 750px) {
            width: 100%;
        }
    }
    .bg{
        height: 0;
        padding-bottom: 100%;
    }
    --swiper-navigation-color: #333;/* 单独设置按钮颜色 */
    --swiper-navigation-size: .2rem;/* 设置按钮大小 */
    .swiper-button-prev,
    .swiper-button-next{
        top: 50%;
        margin-top: 0;
        transform: translate(0, -50%);
        padding: .25rem;
        &.swiper-button-disabled{
            opacity: 0;
        }
    }
    .swiper-button-prev{
        left: 0;
    }
    .swiper-button-next{
        right: 0;
    }
}
</style>